import { resetFormState } from '@store/FormReducer'
import { useAppDispatch } from '@utils/hooks'
import { Layout } from 'antd'
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

export const FormEditorLayout: React.FC = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(resetFormState())
  }, [])

  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}
